module.exports = __webpack_public_path__ + "img/logement-sud.8b54e05d.png";